import axios from "../../rest.config";
import { Credentials } from "vue/types/vue";

class MiscServiceImpl
{
    async appVersion()
    {
        const response = await axios().get('/lemodi/version');
        return response.data;
    }

}

export const MiscService = new MiscServiceImpl();